import { render, staticRenderFns } from "./academy-view-page.vue?vue&type=template&id=59d6bb02&"
import script from "./academy-view-page.vue?vue&type=script&lang=js&"
export * from "./academy-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports